import { useQuery } from "@tanstack/react-query";

import { TIME_INTERVALS } from "shared/lib/constants/time";

import { useApiClient } from "@/context/api-client";
import { CommonQueryKeys } from "@/hooks/queries/keys";

export const useQueryFetchCampaign = (campaignId: string | undefined) => {
  const apiClient = useApiClient();

  return useQuery({
    enabled: !!campaignId,
    queryKey: CommonQueryKeys.campaign(campaignId),
    queryFn: async () => apiClient.getCampaign(campaignId as string),
    select: (response) => response.data,
    staleTime: TIME_INTERVALS.ONE_MINUTE * 5,
  });
};
